export default function getHashParams(paramName?: string) {
  const hash = window.location.hash.substring(1);
  const searchParams = new URLSearchParams(hash);

  // Case 1: When called with no parameter, return the entire hash object
  if (paramName === undefined) {
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

  // Case 2: When called with a parameter name, return that specific value
  return searchParams.get(paramName);
}
